"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Icon = props => (0, jsx_runtime_1.jsx)("span", Object.assign({}, props));
exports.Icon = Icon;
